import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector     : 'empty-page-scroll',
    templateUrl  : './empty.component.html',
    encapsulation: ViewEncapsulation.None
})
export class EmptyPageScrollComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
